export default "__VITE_ASSET__qWLrywx5__"